// extracted by mini-css-extract-plugin
export default {"reference-line-label":"app-canvassers-CanvasserSingle-CanvasserReport-CanvasserScatterPlot-CanvasserScatterPlot-module__wMN8bnLelUnna0XUT2vw"};